import React from 'react'
import { ModularLayout } from '../types'
import {
  DigitalGiftTop,
  DigitalGiftTopOutOfStock,
} from '../../DigitalGiftProductDetailsModules'
import {
  ProductContentDetailsModule,
  ProductLocationsModule,
  PeopleAlsoViewedModule,
  ProductSchemaModule,
} from '../../../modules'

type ModularLayoutFactory = (inStock: boolean) => ModularLayout

export const digitalGifts: ModularLayoutFactory = inStock => ({
  top: [
    inStock ? (
      <DigitalGiftTop key="digital-gift-top" />
    ) : (
      <DigitalGiftTopOutOfStock key="digital-gift-top" />
    ),
  ],
  middleLeft: [
    <ProductContentDetailsModule pb={8} key="product-content-details-module" />,
  ],
  middleRight: [
    <ProductLocationsModule px={6} key="product-locations-module" />,
  ],
  bottom: [
    <PeopleAlsoViewedModule
      key="people-also-viewed-module"
      withContainer
      pt={{ xs: 8, lg: 5 }}
      pb={12}
      bgcolor="colorBackground02"
      borderBottom={1}
      borderColor="colorBlack30"
    />,
    <ProductSchemaModule key="product-schema-module" />,
  ],
})
